import api from '@/service/api';
import variables from "@/service/variables";
export default class ApplyService {
     
    //ApplyHeader
    NewApply_Type1(){
        return api.get(variables.API_URL +'/api/Sourcer/NewApply_Type1')
    }
    GetSourcerApplyList() {
        return api.get(variables.API_URL +'/api/Sourcer/GetSourcerApplyList')
    }
    GetApplyHeader(id) {
        return api.get(variables.API_URL +'/api/Sourcer/GetApplyHeader/' + id)
    }
    CommitApply_Type1(applyHeader) {
        return api.post(variables.API_URL +'/api/Sourcer/CommitApply_Type1',  applyHeader)
    }
    DraftApply_Type1(applyHeader) {
        return api.post(variables.API_URL +'/api/Sourcer/DraftApply_Type1',  applyHeader)
    }


    NewSupervisorApplyHeader(){
        return api.get(variables.API_URL +'/api/VendorApply/NewSupervisorApplyHeader')
    }
    
    GetSupervisorApplyList() {
        return api.get(variables.API_URL +'/api/VendorApply/GetSupervisorApplyList')
    }
    GetSupervisorApply(id) {
        return api.get(variables.API_URL +'/api/VendorApply/GetSupervisorApply/' + id)
    }
    
    
    SupervisorApplyCommit(applyHeader){
        return api.post(variables.API_URL +'/api/VendorApply/SupervisorApplyCommit',  applyHeader)
    }
    SupervisorApplyDraft(applyHeader){
        return api.post(variables.API_URL +'/api/VendorApply/SupervisorApplyDraft',  applyHeader)
    }

    GetSystems() {
        return api.get(variables.API_URL +'/api/VendorApply/GetSystems')
    }
    GetSystemtUser(VIPSystem) {
        return api.get(variables.API_URL +'/api/VendorApply/GetSystemtUser/' + VIPSystem)
    }
    CommitSystemtUser(lstSystemUser){
        return api.post(variables.API_URL +'/api/VendorApply/CommitSystemtUser',  lstSystemUser)
    }

    GetUsers() {
        return api.get(variables.API_URL +'/api/VendorApply/GetUsers')
    }
    GetUserMFGVendorCode(email) {
        return api.get(variables.API_URL +'/api/VendorApply/GetUserMFGVendorCode/' + email)
    }
    CommitUserMFGVendorCode(data){
        return api.post(variables.API_URL +'/api/VendorApply/CommitUserMFGVendorCode',  data)
    }
}
    